import previewLinks from '@/frontend/features/AgentChats/artifacts/previewLinks.js?raw'

export const MAX_DOCUMENT_PREVIEW_BYTES = 1024 * 1024
// Only user-opened tabs leave the sandbox; the preview keeps its opaque origin.
export const HTML_PREVIEW_SANDBOX = 'allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox'
export type DocumentFormat = 'markdown' | 'html'

export function documentFormat(filename: string, contentType: string): DocumentFormat | null {
  const mime = contentType.split(';')[0].trim().toLowerCase()
  if (mime === 'text/html') return 'html'
  if (mime === 'text/markdown') return 'markdown'
  // Some agents/storage adapters return text/plain for both file types.
  if (!['text/plain', 'application/octet-stream', ''].includes(mime)) return null
  if (/\.html?$/i.test(filename)) return 'html'
  if (/\.(md|markdown)$/i.test(filename)) return 'markdown'
  return null
}

export function attachmentUrl(url: string, mode: 'text' | 'document' | 'download'): string {
  const parsed = new URL(url, 'https://workstation.invalid')
  parsed.searchParams.delete('preview')
  parsed.searchParams.delete('download')
  parsed.searchParams.set(mode === 'download' ? 'download' : 'preview', mode === 'download' ? '1' : mode)
  return `${parsed.pathname}${parsed.search}${parsed.hash}`
}

// An iframe sandbox without allow-same-origin protects the app's DOM/storage.
// A CSP placed BEFORE the supplied document also blocks API connections,
// forms and nested frames. Never open this HTML as a same-origin Blob.
export function sandboxedHtml(source: string): string {
  const cdns = 'https://cdnjs.cloudflare.com https://cdn.jsdelivr.net https://unpkg.com'
  const csp = `default-src 'none'; script-src 'unsafe-inline' ${cdns}; style-src 'unsafe-inline' https://fonts.googleapis.com ${cdns}; img-src https: data:; font-src https://fonts.gstatic.com ${cdns}; media-src https: data:; connect-src 'none'; frame-src 'none'; object-src 'none'; base-uri 'none'; form-action 'none'`
  return `<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><meta http-equiv="Content-Security-Policy" content="${csp}"><meta name="referrer" content="no-referrer"><script>${previewLinks}</script></head><body>${source}</body></html>`
}
